import { pickBy, findIndex } from 'lodash';

export const scrollErrorIntoView = (errors) => {
  const errorObj = pickBy(errors);
  const firstError = Object.keys(errorObj)[0];
  const el = document.getElementsByName(firstError)[0];
  const position = el.getBoundingClientRect().top + document.documentElement.scrollTop;

  window.scrollTo({ top: position - 360, behavior: 'smooth' });
};

export const scrollAddOnErrorIntoView = (errors) => {
  const errorIndex = findIndex(errors, (error) => {
    return error.info.count;
  });
  // Trying to find the node in a field array is returned as a single item in a NodeList
  const el = document.getElementsByName(`addOns[${errorIndex}].info.count`).item(0);

  // return if no element
  if (!el) { return; }
  const position = el.getBoundingClientRect().top + document.documentElement.scrollTop;

  window.scrollTo({ top: position - 360, behavior: 'smooth' });
};
